<ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
  <li class="nav-item" role="presentation" *ngFor="let tab of tabs">
    <button
      class="nav-link"
      [class.active]="isActiveTab(tab.id)"
      [attr.id]="tab.id + '-tab'"
      [attr.data-bs-toggle]="tab.disabled ? null : 'pill'"
      [attr.data-bs-target]="'#' + tab.id"
      type="button"
      role="tab"
      [attr.aria-controls]="tab.id"
      [attr.aria-selected]="isActiveTab(tab.id)"
      [attr.disabled]="tab.disabled ? true : null"
      (click)="setActiveTab(tab.id)"
      [attr.aria-label]="'{{ tab.title }}'">
      {{ tab.title }}
    </button>
  </li>
</ul>
<div class="tab-content" id="pills-tabContent">
  <ng-template #tabContent></ng-template>
  <button type="button" class="btn btn-danger mt-3" (click)="removeActiveTab()"
    aria-label="Eliminar Pestaña Activa">
    Eliminar Pestaña Activa
  </button>
</div>
